import React, { useState } from 'react';
import { Box, Typography } from '@mui/material';
import { AddIcon } from 'icons/materialIcons';
import WhiteButtonWithIcon from 'components/common/button/WhiteButtonWithIcon';
import UpgradeSnackBar from 'components/common/notification/UpgradeSnackBar';
import { useNavigate } from 'react-router-dom';

const IntegrationsMenu = () => {
    const [open, setOpen] = useState(false);
    const navigate = useNavigate();

    const handleRequestIntegration = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleSubscribe = () => {
        handleClose();
        navigate('/dashboard/subscribe');
    };

    return (
        <>
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    flexWrap: 'wrap',
                    gap: 2,
                    mb: 3
                }}
            >
                <Typography variant="h6" component="h1">
                    Integrations
                </Typography>

                <WhiteButtonWithIcon
                    text="Request an Integration"
                    icon={AddIcon}
                    onClick={handleRequestIntegration}
                    sx={{
                        fontWeight: 700
                    }}
                    iconPosition="start"
                />
            </Box>

            <UpgradeSnackBar
                open={open}
                handleClose={handleClose}
                handleSubscribe={handleSubscribe}
                message="Upgrade to Pro or Pro Plus for access to integrations"
            />


        </>
    );
};

export default IntegrationsMenu;